import { Controller } from "@hotwired/stimulus"

// One control for the three format previews, including an explicit retry state.
export default class extends Controller {
  static targets = ["pause", "label", "status"]
  static outlets = ["format-preview"]

  initialize() {
    this.paused = false
    this.interrupted = false
    this.unsupported = false
  }

  connect() {
    this.motion = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.render = this.render.bind(this)
    this.motion.addEventListener("change", this.render)
    this.render()
  }

  disconnect() {
    this.motion.removeEventListener("change", this.render)
  }

  formatPreviewOutletConnected(preview) {
    preview.setPaused(this.paused || this.interrupted)
  }

  togglePause() {
    const resume = this.paused || this.interrupted
    this.paused = !resume
    this.interrupted = false
    this.statusTarget.textContent = ""
    this.formatPreviewOutlets.forEach(preview => preview.setPaused(this.paused))
    this.render()
  }

  unavailable({ detail: { autoplay, unsupported = false } }) {
    this.interrupted = true
    this.unsupported = unsupported
    this.statusTarget.textContent = unsupported
      ? "Previews are unavailable in this browser. Open a recording to watch."
      : autoplay
      ? "Previews could not autoplay. Play to start."
      : "Previews interrupted. Play to retry."
    this.formatPreviewOutlets.forEach(preview => preview.setPaused(true))
    this.render()
  }

  render() {
    const stopped = this.paused || this.interrupted
    this.pauseTarget.hidden = this.motion.matches || this.unsupported
    this.pauseTarget.setAttribute("aria-pressed", String(stopped))
    this.labelTarget.textContent = stopped ? "Play all previews" : "Pause all previews"
  }
}
